import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";

type Items = {
  Colour: string;
  ColourDescription: string;
  Images: unknown[];
  IsAvailableInStore: true;
  IsBreathTakingItem: false;
  ItemId: string;
  ItemType: string;
  ItemUnitCode: string;
  LatestSalesDate?: string;
  Name: string;
  PaNumber: string;
  PredictedAssemblyTime: number;
  ProductType: string;
};

const fetchMFSSearchData = async (query: string) => {
  const response = await httpClient.tasks.get<{ Items: Items[] }>(
    `/v1/products/mfs_search?query=${query}`
  );
  const items = response?.Items;
  return items?.[0]?.LatestSalesDate;
};

export function useEdsDateMFSSearch(query: string) {
  return useQuery({
    queryKey: ["mfs", "search", query],
    queryFn: async () => await fetchMFSSearchData(query),
    staleTime: 86400000, // Since this data does not change frequently, it can stay fresh for a long time
    refetchOnWindowFocus: false,
    enabled: !!query,
  });
}
